<template>
    <div class="card">
        <Toolbar class="mb-4">
            <template slot="left">
                <label>PAGOS DEL SERVICIO</label>
            </template>
        </Toolbar>
        <Toolbar class="mb-4">
            <template slot="left">
                <div class="p-fluid p-grid col-md-12">
                    <div class="col-md-2">
                        <label for="cedula">Cédula</label>
                        <InputText id="cedula" type="text" disabled v-model="cliente.cedula" />
                    </div>
                    <div class="col-md-2" style="margin-left: 10px">
                        <label for="nombres">Nombres</label>
                        <InputText id="cedula" type="text" disabled v-model="cliente.nombres" />
                    </div>
                    <div class="col-md-2" style="margin-left: 10px">
                        <label for="nombres">No. medidor</label>
                        <InputText id="cedula" type="text" disabled v-model="cliente.numeroMedidor" />
                    </div>
                    <div class="col-md-2" style="margin-left: 10px">
                        <label for="buscar">&nbsp;&nbsp;</label>
                        <div class="col-md-2">
                            <Button id="buscar" icon="pi pi-search" v-tooltip="'Buscar cliente'" style="width:50px;" class="p-button-primary" @click="buscarCliente()" />
                        </div>							
                    </div>
                    <div class="col-md-2" style="margin-left: 10px">
                        <label for="buscar">&nbsp;&nbsp;</label>
                        <div class="col-md-2">
                            <Button id="buscar" icon="pi pi-check-circle" v-tooltip="'Limpiar formulario'" style="width:50px;" class="p-button-warning"  />
                        </div>							
                    </div>
                </div>
            </template>
        </Toolbar>
        <div class="p-grid p-fluid dashboard">
            <div class="p-col-12 p-md-6 p-lg-7">
                <DataTable
                    class="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-responsive p-datatable-customers"
                    :value="dataFacturasPendientes"
                    :rowHover="true"
                    dataKey="id"
                    :paginator="true"
                    :rows="100"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrar {first} hasta {last} de {totalRecords} Registros">
                    <template #header>
                        <div class="table-header">
                            <h5 class="p-m-0"> Planillas por cobrar </h5>
                        </div>
                    </template>
                    <template #empty> No se encontraron Registros. </template>
                    <template #loading> Cargando Registros, por favor espere un momento. </template>
                    <Column field="id" header="No. Pla" >
                        <template #body="slotProps">
                            <span class="p-column-title"> No. Pla:</span>
                            {{ slotProps.data.id }}
                        </template>
                    </Column>
                    <Column field="mes" header="Mes">
                        <template #body="slotProps">
                            <span class="p-column-title"> Mes:</span>
                            <span  :class="'customer-badge'">{{slotProps.data.mes}} </span>
                        </template>
                    </Column>
                    <Column field="anio" header="Año">
                        <template #body="slotProps">
                            <span class="p-column-title"> Año:</span>
                            <span  :class="'customer-badge'">{{slotProps.data.anio}} </span>
                        </template>
                    </Column>
                    <Column field="totalpagar" header="Valor">
                        <template #body="slotProps">
                            <span class="p-column-title"> Valor:</span>
                            <span  :class="'customer-badge'">{{ slotProps.data.totalpagar }} </span>
                        </template>
                    </Column>
                    <Column field="abono" header="Abono">
                        <template #body="slotProps">
                            <span class="p-column-title"> Abono:</span>
                            <span  :class="'customer-badge'">{{ slotProps.data.abono }} </span>
                        </template>
                    </Column>
                    <Column field="saldo" header="Saldo" >
                        <template #body="slotProps">
                            <span class="p-column-title"> Saldo:</span>
                            <span  :class="'customer-badge'">{{ slotProps.data.saldo }} </span>
                        </template>
                    </Column>
                    <Column headerStyle="width: 5em;">
                        <template #body="slotProps">
                            <Button icon="pi pi-eye" class="p-button-rounded p-button-primary p-mr-2" v-tooltip="'Ver detalles'" />
                        </template>
                    </Column>
                </DataTable>
            </div>
            <div class="p-col-12 p-md-6 p-lg-5">
                <Panel header="Datos" style="height: 100%">
                    <ul class='task-list'>
                        <li>
                            <div class="p-field p-grid">
                                <label class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">Total pagar:</label>
                                <div class="p-col-12 p-md-9">
                                    <InputText id="codigo" v-model.trim="totalpagar" disabled />
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="p-field p-grid">
                                <label class="p-col-12 p-mb-2 p-md-3 p-mb-md-0">Abono:</label>
                                <div class="p-col-12 p-md-9">
                                    <InputText id="codigo" v-model.trim="abonar" />
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="row justify-content-center ">
                                <Button label="Grabar" icon="pi pi-save" style="width:110px;margin-right:10px" class="p-button-primary" v-tooltip="'Grabar factura'" @click="grabarFactura()" />
                                <Button label="Detalles" icon="pi pi-eye" style="width:110px;margin-right:10px" class="p-button-warning p-mr-2" v-tooltip="'Ver detalles de factura'" @click="verDetallesFactura()" />
                            </div>
                        </li>
                    </ul>
                </Panel>
            </div>
            <Dialog :visible.sync="clientesDialog" :style="{ width: '800px' }" :header="textocliente" :modal="true" class="p-fluid" position="top" @hide="cerrarDialogo">
                <div class="col-md-12 p-lg-12">
                    <DataTable
                        class="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-responsive p-datatable-customers"
                        :value="dataCliente"
                        :rowHover="true"
                        dataKey="id"
                        :paginator="true"
                        :rows="8"
                        :filters="filters"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrar {first} hasta {last} de {totalRecords} Registros">
                        <template #header>
                            <div class="table-header">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search" />
                                    <InputText v-model="filters['global']" placeholder="Buscar..." />
                                </span>
                            </div>
                        </template>
                        <template #empty> No se encontraron Registros. </template>
                        <template #loading> Cargando Registros, por favor espere un momento. </template>
                        <Column field="cedula" header="Cédula" headerStyle="width: 8em;">
                            <template #body="slotProps">
                                <span class="p-column-title"> Cédula:</span>
                                {{ slotProps.data.cedula }}
                            </template>
                        </Column>
                        <Column field="nombres" header="Nombres">
                            <template #body="slotProps">
                                <span class="p-column-title"> Nombres:</span>
                                <span  :class="'customer-badge'">{{ slotProps.data.nombres }} </span>
                            </template>
                        </Column>
                        <Column field="apellidos" header="Apellidos">
                            <template #body="slotProps">
                                <span class="p-column-title"> Apellidos:</span>
                                <span  :class="'customer-badge'"> {{ slotProps.data.apellidos }} </span>
                            </template>
                        </Column>
                        <Column field="telefono" header="Teléfono" headerStyle="width: 8em;">
                            <template #body="slotProps">
                                <span class="p-column-title"> Teléfono:</span>
                                <span  :class="'customer-badge'">{{ slotProps.data.telefono }} </span>
                            </template>
                        </Column>
                        <Column headerStyle="width: 5em;">
                            <template #body="slotProps">
                                <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" @click="seleccionarCliente(slotProps.data)" />
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <template #footer>
                    <Button label="Salir" icon="pi pi-times" class="p-button-warning p-mr-2" @click="cerrarDialogo()" />
                </template>
            </Dialog>
            <Dialog :visible.sync="detalleFacturaDialog" :style="{ width: '800px' }" :header="textoDetalleFactura" :modal="true" class="p-fluid" position="top" @hide="cerrarDialogoDetalleFactura">
                <div class="col-md-12 p-lg-12">
                    <DataTable
                        class="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-responsive p-datatable-customers"
                        :value="dataDetalleFactura"
                        :rowHover="true"
                        dataKey="id"
                        :paginator="true"
                        :rows="8"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrar {first} hasta {last} de {totalRecords} Registros">
                        <template #empty> No se encontraron Registros. </template>
                        <template #loading> Cargando Registros, por favor espere un momento. </template>
                        <Column field="cantidad" header="Cantidad">
                            <template #body="slotProps">
                                <span class="p-column-title"> Cantidad:</span>
                                {{ slotProps.data.cantidad }}
                            </template>
                        </Column>
                        <Column field="descripcion" header="Descripción">
                            <template #body="slotProps">
                                <span class="p-column-title"> Descripcion:</span>
                                <span  :class="'customer-badge'">{{ slotProps.data.descripcion }} </span>
                            </template>
                        </Column>
                        <Column field="total" header="Total">
                            <template #body="slotProps">
                                <span class="p-column-title"> Total:</span>
                                <span  :class="'customer-badge'"> {{ slotProps.data.total }} </span>
                            </template>
                        </Column>
                        <Column field="abono" header="Abono">
                            <template #body="slotProps">
                                <span class="p-column-title"> Abono:</span>
                                <span  :class="'customer-badge'"> {{ slotProps.data.abono }} </span>
                            </template>
                        </Column>
                        <Column field="saldo" header="Saldo" >
                            <template #body="slotProps">
                                <span class="p-column-title"> Saldo:</span>
                                <span  :class="'customer-badge'">{{ slotProps.data.saldo }} </span>
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <template #footer>
                    <Button label="Salir" icon="pi pi-times" class="p-button-warning p-mr-2" @click="cerrarDialogoDetalleFactura()" />
                </template>
            </Dialog>
            <DialogProgreso
                :showProgreso="showProgreso"
                :titulo="mensajeCargando">
            </DialogProgreso>
        </div>
    </div>
</template>

<script>
import Globals from "../../js/Globales";
import ClienteService from "../../service/administracion/ClienteService";
import PlanillaService from "../../service/administracion/PlanillaService";
import DialogProgreso from "../componentesglobales/DialogoProgreso.vue";
import FacturaService from "../../service/administracion/FacturaService";
import Swal from 'sweetalert2';

export default {
    data() {
        return {
            cliente: {},
            dataFacturasPendientes: [],
            clientesDialog: false,
            textocliente: null,
            dataCliente: [],
            filters: {},
            position: "top",
            rango: Globals[0].paginacion.rango,
            totalpagar: 0,
            abonar: 0,
            detalleFacturaDialog: false,
            dataDetalleFactura: [],
            textoDetalleFactura: null,
            showProgreso: null,
            mensajeCargando: null,
        };        
    },
    clienteService: null,
    planillaService: null,
    facturaService: null,
    created() {
        this.clienteService = new ClienteService();
        this.planillaService = new PlanillaService();
        this.facturaService = new FacturaService();
    },
    mounted() {
        this.cargarClientes();
    },
    components: {
        'DialogProgreso': DialogProgreso,
    },
    
    methods: {
        cargarClientes(){
            this.dataCliente = [];
            this.clienteService.buscarClientesActivos().then((response) => {
                this.dataCliente = response.data;
            }).catch(() => {
            });
        },

        buscarCliente(){
            this.textocliente = "Listado de clientes";
            this.clientesDialog = true;
            this.filters = {};
        },

        seleccionarCliente(data){
            this.dataFacturasPendientes = [];
            this.totalpagar = 0;
            Swal.fire({
                title: 'Cargando...',
                html: 'por favor, espere!...',
                allowOutsideClick: false,
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
            });
            this.planillaService.consultardeudascliente(data.id).then( response => {
                Swal.close();
                let respuesta = response.data;
                if( respuesta.status == "error" ){
                    Swal.fire({position: 'top', title: 'Advertencia!', text: "" + respuesta.mensaje + "", icon: 'warning', showConfirmButton: true, timer: 6000});
                    return;
                }else{
                    this.clientesDialog = false;
                    this.dataFacturasPendientes = respuesta.data;
                    this.cliente = data;
                    this.calculartotalpagar(respuesta.data);
                }
            }).catch( error => {
                Swal.close();
                console.log(error);
            });
        },

        calculartotalpagar(data){
            this.totalpagar = 0;
            let total = 0;
            for (let i = 0; i < data.length; i ++) {
                total = total + data[i].saldo;
            }
            this.totalpagar = total;
        },

        verDetallesFactura(){
            if(this.cliente == null || this.cliente == undefined){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar un cliente", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
            if(this.abonar == 0 || this.abonar == null || this.abonar == "" || this.abonar == undefined){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe ingresar valor a abonar", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
            this.textoDetalleFactura = "Detalles de factura a generar";
            this.detalleFacturaDialog = true;
            this.dataDetalleFactura = [];
            //hacer los calculos correspondientes
            let totalabono = this.abonar;
            for (let i = 0; i < this.dataFacturasPendientes.length; i ++) {
                let totalfac = this.dataFacturasPendientes[i].saldo;
                if(totalabono > 0) {
                    if(totalabono >= totalfac){
                        this.dataDetalleFactura.push( {
                            cantidad: this.dataFacturasPendientes[i].totalpagar,
                            descripcion: "Consumo mes: " + this.dataFacturasPendientes[i].mes + "/" + this.dataFacturasPendientes[i].anio + " por: " + this.dataFacturasPendientes[i].totalpagar + "m3",
                            abono: totalfac,
                            total: totalfac,
                            saldo: 0
                        }); 
                        totalabono = totalabono - totalfac;
                    }else{
                        this.dataDetalleFactura.push( {
                            cantidad: this.dataFacturasPendientes[i].totalpagar,
                            descripcion: "Abono planilla mes: " + this.dataFacturasPendientes[i].mes + "/" + this.dataFacturasPendientes[i].anio + " por: " + this.dataFacturasPendientes[i].totalpagar + "m3",
                            abono: totalabono,
                            total: totalfac,
                            saldo: totalfac - totalabono
                        });
                        totalabono = 0;
                    }
                }
            }
        },

        grabarFactura(){
            if(this.cliente == null || this.cliente == undefined){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar un cliente", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
            if(this.abonar == 0 || this.abonar == null || this.abonar == "" || this.abonar == undefined){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe ingresar valor a abonar", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
            let user = JSON.parse(localStorage.getItem('user'));
            let datos = {
                planillaspendiente: this.dataFacturasPendientes,
                abono: this.abonar,
                cliente: this.cliente,
                usuario: user.usuario
            }
            
            Swal.fire({ title: 'Grabar datos', text: "Esta seguro de realizar el proceso" , icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Si', cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
						title: 'Cargando...',
						html: 'por favor, espere!...',
						allowOutsideClick: false,
						onBeforeOpen: () => {
							Swal.showLoading()
						},
					});
                    this.facturaService.grabarFactura(datos).then( response => {
                        Swal.close();
                        let data = response.data;
                        if( data.status == "ok" ){
                            Swal.fire({ position: 'center', customClass: { container: 'my-swal' }, title: 'Correcto!', text: "" + data.mensaje + "", icon: 'success', showConfirmButton: true, timer: 6000 });
                            this.imprimirFactura( data.idfactura, this.cliente.cedula );
                            this.limpiarFormulario();
                        }else{
                            Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al grabar", icon: 'warning', showConfirmButton: true, timer: 6000 });
                        }
                    }).catch( error => {
                        Swal.close();
                        console.log(error);
                        Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al grabar", icon: 'warning', showConfirmButton: true, timer: 6000 });
                    });
                }
            });
        },

        imprimirFactura(numerofactura, cedula){
            this.mensajeCargando = "Generando planilla";
            this.showProgreso = true;
			this.facturaService.imprimirFactura( numerofactura ).then(response => {
                var headers = response.headers;
                var blob = new Blob([response.data],{type:headers['content-type']});
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = "Factura-" + numerofactura + "-" + cedula;
                link.click();
				this.showProgreso = false;
            })
            .catch(() => {
            });
        },

        cerrarDialogo(){
            this.clientesDialog = false;
        },

        cerrarDialogoDetalleFactura(){
            this.detalleFacturaDialog = false;
        },

        limpiarFormulario(){
            this.cliente = {};
            this.dataFacturasPendientes = [];
            this.clientesDialog = false;
            this.textocliente = null;
            this.totalpagar = 0;
            this.abonar = 0;
            this.detalleFacturaDialog = false;
            this.dataDetalleFactura = [];
            this.textoDetalleFactura = null;
            this.filters = {};
        }

    }
}
</script>
<style lang="scss" scoped>
    .table-header {
        display: flex;
        justify-content: space-between;
    }
    .p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
    display: none;
}
@media screen and (max-width: 960px) {
	/deep/ .p-datatable {
		&.p-datatable-customers {
			.p-datatable-thead > tr > th,
			.p-datatable-tfoot > tr > td {
				display: none !important;
			}
			.p-datatable-tbody > tr {
				> td {
					text-align: left;
					display: block;
					border: 0 none !important;
					width: 100% !important;
					float: left;
					clear: left;
					border: 0 none;
					.p-column-title {
						padding: .4rem;
						min-width: 30%;
						display: inline-block;
						margin: -.4rem 1rem -.4rem -.4rem;
						font-weight: bold;
					}
					.p-progressbar {
						margin-top: .5rem;
					}
				}
			}
		}
	}
}

    .buttonAzul{
        background-color: #14334d;
        color: #FFFFFF;
    }

    .buttonBlancoAzul{
        background-color: #FFFFFF;
        color: #14334d;
        border: 1px solid #14334d;
    }

    .buttonBlancoRojo{
        background-color: #FFFFFF;
        color: #d32f2f;
        border: 1px solid #d32f2f;
    }

    .buttonRojo{
        background-color: #d32f2f;
        color: #FFFFFF;
    }
    @media screen and (max-width: 960px) {
		/deep/ .p-datatable {
			&.p-datatable-customers {
				.p-datatable-thead > tr > th,
				.p-datatable-tfoot > tr > td {
					display: none !important;
				}

				.p-datatable-tbody > tr {
					border-bottom: 1px solid #dee2e6;
					> td {
						text-align: left;
						display: flex;
						align-items: center;
						justify-content: center;
						border: 0 none !important;
						width: 100% !important;
						float: left;
						clear: left;
						border: 0 none;

						.p-column-title {
							padding: .4rem;
							min-width: 30%;
							display: inline-block;
							margin: -.4rem 1rem -.4rem -.4rem;
							font-weight: bold;
						}

						.p-progressbar {
							margin-top: .5rem;
						}
					}
				}
			}
		}
	}
</style>